<template>
  <div class="onboarding-home">
    <OnboardingWelcome
      v-if="!isStartingForm"
      @toggle-starting="toggleIsStartingStatus"
    />

    <OnboardingStepperFirstEditor
      v-if="isStartingForm && isFirstEditor"
      :stepper-processing="finishWizard"
      :onboarding-data="onboardingData"
    />

    <OnboardingStepperSecondEditor
      v-if="isStartingForm && !isFirstEditor"
      :stepper-processing="finishWizard"
      :onboarding-data="onboardingData"
    />

    <div class="onboarding-home__empty-div" />
  </div>
</template>

<script>
import OnboardingWelcome from '@/components/onboarding/OnboardingWelcome';
import OnboardingStepperFirstEditor from '@/components/onboarding/OnboardingStepperFirstEditor';
import OnboardingStepperSecondEditor from '@/components/onboarding/OnboardingStepperSecondEditor';

import { ONBOARDING_STATUS, DASHBOARD_MODELS } from '@/utils/constants';
import { trackEventWithUserProperties } from '@/utils/mixpanel';
import onboardingModel from '@/mixins/onboarding-model';
import { mapActions, mapGetters, mapState } from 'vuex';
import { FILTER_NAMES } from '@/store/modules/cards/constants';

export default {
  name: 'OnboardingHome',
  components: {
    OnboardingWelcome,
    OnboardingStepperFirstEditor,
    OnboardingStepperSecondEditor,
  },
  mixins: [
    onboardingModel,
  ],
  data() {
    return {
      isStartingForm: false,
      onboardingData: {
        job: '',
        otherJob: '',
        department: '',
        otherDepartment: '',
        useCases: [],
        otherUseCases: [],
        dashboardName: '',
        templateType: '',
        choosenDashboard: '',
      },
    };
  },
  computed: {
    ...mapState('user', [
      'user',
    ]),
    ...mapGetters('dashboard', [
      'activeDashboard',
    ]),
    hasDashboardName() {
      return Boolean(this.onboardingData.dashboardName.length) ? this.onboardingData.dashboardName : this.onboardingData.templateType;
    },
  },
  methods: {
    ...mapActions('dashboard', [
      'getDashboardByUniAndDashId',
      'updateDashboard',
      'saveOnboardingData',
    ]),
    toggleIsStartingStatus() {
      this.isStartingForm = !this.isStartingForm;
    },
    finishWizard() {
      const editorType = this.getEditorType();

      const onboardingInformation = {
        ...this.onboardingData,
        editorType,
      };

      this.updateUserOnboarding(ONBOARDING_STATUS.DONE);
      this.saveOnboardingData(onboardingInformation);

      if (this.isFirstEditor) {
        this.createDashboardBasedOnTemplate();
      }

      trackEventWithUserProperties('ST OnboardingWizard FinishButton Click', { editorType });
      this.$router.push({ name: 'home' });
    },
    async createDashboardBasedOnTemplate() {
      const foundedUniverseId = this.getUniverseId();
      const dashboardData = await this.getDashboardByUniAndDashId({ universeId: foundedUniverseId.universeId, dashboardId: this.onboardingData.choosenDashboard });
      const {
        cards,
        description = '',
      } = dashboardData.data();
      const copiedCards = this.removeUncopyableFiltersFromCards(cards);

      const dashboard = {
        expiresTrialDate: null,
        title: this.hasDashboardName,
        cards: copiedCards,
        onboardingStatus: ONBOARDING_STATUS.DONE,
        description,
      };

      this.updateDashboard({
        dashboard,
      });
    },
    getUniverseId() {
      return DASHBOARD_MODELS.find(value => value.id === this.onboardingData.choosenDashboard);
    },
    removeUncopyableFiltersFromCards(cards) {
      const copyableFilters = [
        FILTER_NAMES.GENDER,
        FILTER_NAMES.POLARITY,
        FILTER_NAMES.FAVORITE,
        FILTER_NAMES.DARK_POST,
        FILTER_NAMES.SAC_TYPE,
        FILTER_NAMES.SAC_STATUS,
        FILTER_NAMES.SAC_LAST_STATUS,
      ];

      const newCards = cards?.map((card) => {
        const areThereFilters = Boolean(card.props?.filter && card.props?.filter !== {});

        if (!areThereFilters) {
          return card;
        }

        const newCard = { ...card };
        const filters = {};

        Object.keys(newCard?.props?.filter).forEach(singleFilter => {
          const isThereFilterToCopy = copyableFilters.includes(singleFilter);

          if (isThereFilterToCopy) {
            filters[singleFilter] = newCard.props.filter[singleFilter];
          }
        });

        delete newCard.props.filter;
        newCard.props.filter = filters;

        return newCard;
      });

      return newCards;
    },
  },
};
</script>

<style lang="scss" scoped>
  .onboarding-home {
    display: flex;
    justify-content: space-between;
    background-color: var(--ds-color-background);
    padding-top: 56px;
    height: 100vh;
    width: 100vw;

    &__empty-div {
      width: 171px;
      height: 100%;
      background-color: var(--ds-color-brand-3);
    }
  }
</style>
